import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Slide from '@material-ui/core/Slide';
import { DeereCachedFetch } from '../../shared/fetch';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import dstyles from './AlfaMessageDialog.module.css';
import { withStyles } from '@material-ui/core/styles';


const StyledTableCell = withStyles((theme) => ({
    head: {
        backgroundColor: '#367C2B',
        color: theme.palette.common.white
    },
    body: {
        fontSize: 14
    }
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
    root: {
        '&:nth-of-type(odd)': {
            backgroundColor: theme.palette.action.hover
        }
    }
}))(TableRow);

const styles = {
    body: {
        display: 'flex',
        flexDirection: 'row',
        margin: 2
    },
    button: {
        zIndex: 1000,
        height: 100,
        width: 100,
        margin: 6.5,
        borderRadius: 0

    },
    wrapper: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between'
    },
    container: {
        display: 'flex',
        flexDirection: 'row',
        flex: 1,
        flexWrap: 'wrap',
        margin: '5px 50px',
        backgroundColor: 'white',
        padding: 6.5
    },
    modal: {
        position: 'absolute',
        width: 400,
        backgroundColor: 'white',
        boxShadow: 'none',
        padding: 10,
        outline: 'none',
        top: '15%',
        left: '50%',
        transform: 'translate(-50%, -50%)'
    }
};
const Transition = React.forwardRef((props, ref) => {
    return <Slide direction="up" ref={ref} {...props} />;
});
Transition.displayName = 'Transition';

export class AlfaMessageDialog extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            open: false,
            message: [],
            bundleID: ''
        };
    }
    async getAlfaMessages() {

        const alfaMessages = await DeereCachedFetch('/api/alfamessages', {
            query: {
                bundleNumber: this.props.bundleNumber
            }
        });
        return alfaMessages;
    }

  handleOpen = () => async () => {
      this.setState({ open: true, message:[{updatedDate:'-', message:'Loading....', messageType:'-'} ]});
      const alfaMessages = await this.getAlfaMessages();

      this.setState({ open: true, message: alfaMessages });
  };

  handleClose = () => {
      this.setState({ open: false });
  };
  render() {
      const { message } = this.state;

      return (
          <div style={styles.wrapper}>
              <div style={styles.body}>
                  <Button
                      color="primary"
                      onClick={this.handleOpen()}
                      variant="outlined"

                  >
                      View
                  </Button>



                  <Dialog
                      TransitionComponent={Transition}
                      aria-describedby="alert-dialog-slide-description"
                      aria-labelledby="alert-dialog-slide-title"
                      keepMounted
                      maxWidth="md"
                      onClose={this.handleClose}
                      // fullWidth="300"
                      open={this.state.open}
                  >
                      <DialogTitle id="alert-dialog-slide-title">
                          {'Message Details'}<hr />
                      </DialogTitle>
                      <DialogContent>


                          <TableContainer component={Paper}>
                              <Table aria-label="simple table" className={dstyles.dtable}>
                                  <TableHead>
                                      <TableRow>
                                          <StyledTableCell >Date</StyledTableCell >
                                          <StyledTableCell>Message</StyledTableCell>
                                          <StyledTableCell>Message Type</StyledTableCell>

                                      </TableRow>
                                  </TableHead>
                                  <TableBody>
                                      {message.map((row) => (
                                          <StyledTableRow key={row.updatedDate}>

                                              <StyledTableCell >{row.updatedDate && row.updatedDate.length>9?row.updatedDate.substring(0, row.updatedDate.length-9):''}</StyledTableCell>
                                              <StyledTableCell >{row.message}</StyledTableCell>
                                              <StyledTableCell >{row.messageType}</StyledTableCell>

                                          </StyledTableRow>
                                      ))}


                                  </TableBody>
                              </Table>
                          </TableContainer>
                      </DialogContent>
                      <DialogActions>
                          <Button color="primary" onClick={this.handleClose}>
                              close
                          </Button>

                      </DialogActions>
                  </Dialog>
              </div>
          </div>
      );
  }
}


